<template>
  <!--  page starting div -->

  <div class="start-page" style="margin-top: -10px !important">
    <template v-if="CheckedCount == 0">
      <b-row class="px-pad border-bottom" style="height: 42px">
        <b-col md="6" class="px-0">
          <!-- custom filter dropdown -->
          <b-dropdown
            variant="link"
            class="index-filter-heading"
            toggle-class="text-decoration-none"
            size="sm"
            dropdown
            :text="filter_name"
          >
            <div class="dropdownitem-list">
              <b-dropdown-item
                :class="{ filter_dropdown: true }"
                :to="{
                  name: 'AccountSettings',
                  query: {
                    page: 1,
                    show: 10,
                    search: search_criteria,
                    status: status,
                    sort: sort,
                    label: label,
                    status: item.status_id,
                    custom: custom,
                  },
                }"
                v-for="item in filter_list"
                :key="item.status_id"
                v-if="item.status_name != filter_name"
                >{{ item.status_name }}</b-dropdown-item
              >
            </div>
          </b-dropdown>
          <!-- edit button for custom filter dropdown -->
        </b-col>
        <b-col md="6" class="text-right">
          <!-- To add new Account -->
          <b-button
            variant="primary"
            @click="accountsform"
            size="sm"
            class="mr-2"
            v-if="!$route.query.custom"
          >
            <i class="fa fa-plus pr-2"></i>New Account
          </b-button>
          <!-- Account Export -->
          <b-dropdown
            v-if="RoutePermission(false, '', '', 'settings', 'export')"
            dropdown
            text="☰"
            variant="light"
            size="sm"
            class="no-caret-dropdown ml-2"
          >
            <b-dropdown-item @click="exportModal()">
              <span class="no_caret_import la la-download mr-3"></span>Export
            </b-dropdown-item>
          </b-dropdown>
          <router-link
            class="text-dark float-right"
            :to="{
              name: 'AccountSettings',
              query: {
                page: page,
                show: count,
                search: '',
                sort: sort,
                label: label,
              },
            }"
          >
            <i
              class="la la-times-circle-o la-lg float-right mar-top-close text-decoration-none mt-2 ml-2"
              v-if="$route.query.custom"
            ></i>
          </router-link>
        </b-col>
      </b-row>
    </template>
    <b-row>
      <b-col cols="12" class="px-0">
        <!--  row for bulk delete option and acitve and inactive if atleast one checkbox is selected in the table -->
        <b-row
          style="height: 42px"
          class="px-pad border-bottom"
          v-if="CheckedCount > 0"
        >
          <b-col xl="6" lg="6" md="6" sm="6" xs="6">
            <b-button
              size="sm"
              variant="light"
              class="text-left mr-2"
              @click="deletemodal"
            >
              <i class="fa fa-trash"></i>
            </b-button>
            <b-button
              @click="(statusPage = 'active'), (modalPage = '')"
              v-b-modal.statusPage
              variant="light"
              size="sm"
              class="text-left mr-2"
              >Active</b-button
            >
            <b-button
              @click="statusPage = 'inactive'"
              v-b-modal.statusPage
              variant="light"
              size="sm"
              class="text-left"
              >Inactive</b-button
            >
          </b-col>
          <b-col xl="6" lg="6" md="6" sm="6" xs="6">
            <i
              v-on:click="
                checkAll({
                  target: {
                    checked: false,
                  },
                }),
                  (CheckedCount = 0),
                  (checkboxes1[0] = false)
              "
              class="la la-times-circle-o la-lg float-right mar-top-close"
            ></i>
          </b-col>
        </b-row>
        <div class="table-responsive" id="scrollCol">
          <!-- Table -->
          <table class="table table-hover index-table">
            <thead>
              <!-- Thead for table -->
              <tr>
                <th style="width: 54px !important">
                  <div class="abc-checkbox text-left">
                    <input
                      type="checkbox"
                      id="checkboxall"
                      v-model="checkboxes1[0]"
                      @change="(event) => checkAll(event)"
                    />
                    <label for="checkboxall" />
                  </div>
                </th>
                <th style="width: 50px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{
                      name: 'AccountSettings',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'gl_acc_name',
                        custom: custom,
                      },
                    }"
                  >
                    Accounts Name
                    <small class="text-muted" v-if="label == 'gl_acc_name'">
                      <i
                        :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                        style="font-weight: thinner"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="width: 50px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{
                      name: 'AccountSettings',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'acc_code',
                        custom: custom,
                      },
                    }"
                  >
                    Account Code
                    <small class="text-muted" v-if="label == 'acc_code'">
                      <i
                        :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                        style="font-weight: thinner"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="width: 50px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{
                      name: 'AccountSettings',
                      query: {
                        page: page,
                        show: show,
                        search: search_criteria,
                        status: status,
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'gl_acc_type',
                        custom: custom,
                      },
                    }"
                  >
                    Type
                    <small class="text-muted" v-if="label == 'gl_acc_type'">
                      <i
                        :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                        style="font-weight: thinner"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th class="text-right" style="width: 5px !important"></th>
              </tr>
            </thead>
            <tbody>
              <!-- Tbody when no list is present -->
              <template v-if="lists.length == 0">
                <tr>
                  <td colspan="6" class="text-center">No data to display</td>
                </tr>
              </template>
              <!-- Tbody for table -->
              <template v-else>
                <tr v-for="(list, index) in lists" :key="list.id">
                  <td>
                    <div class="abc-checkbox text-left">
                      <input
                        type="checkbox"
                        v-model="checkboxes1[index + 1]"
                        :id="'checkbox' + (index + 1)"
                        :true-value="list.gl_acc_id"
                        :value="list.gl_acc_id"
                        @change="
                          (event) =>
                            changeCheck(event, 'checkboxes1', index + 1)
                        "
                      />
                      <label :for="'checkbox' + (index + 1)" />
                    </div>
                  </td>
                  <td style="width: 50px !important">
                    {{ list.gl_acc_name }}
                  </td>
                  <td style="width: 50px !important">{{ list.acc_code }}</td>
                  <td style="width: 50px !important">
                    {{ list.gl_acc_type }}
                  </td>

                  <td
                    class="text-right cursor_pointer text-link"
                    style="width: 50px !important"
                  >
                    <i
                      v-if="list.gl_acc_id >= 81"
                      class="fa fa-pencil"
                      @click="callupdateaccountsmodal(index)"
                    ></i>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!-- pagination -->
      </b-col>
    </b-row>
    <b-row
      v-if="lists.length > 0"
      style="width: 100%; position: absolute; border-top: 1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" cols="8" class="mt-2 pt-1 px-0">
        <nav class="float-left">
          <p>
            Showing {{ total_count != 0 ? (page - 1) * count + 1 : 0 }} to
            {{ (page - 1) * show + lists.length }} of {{ total_count }} entries
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :text="count"
                left
              >
                <router-link
                  :to="{
                    name: 'AccountSettings',
                    query: {
                      page: 1,
                      show: 10,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10"
                    >10</b-dropdown-item-button
                  >
                </router-link>
                <router-link
                  :to="{
                    name: 'AccountSettings',
                    query: {
                      page: 1,
                      show: 25,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25"
                    >25</b-dropdown-item-button
                  >
                </router-link>
                <router-link
                  :to="{
                    name: 'AccountSettings',
                    query: {
                      page: 1,
                      show: 50,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50"
                    >50</b-dropdown-item-button
                  >
                </router-link>
              </b-dropdown>
            </span>
            rows per page
          </p>
        </nav>
      </b-col>
      <b-col
        xl="2"
        md="2"
        lg="2"
        sm="12"
        style="text-align: center"
        class="mt-2 pt-1 pl-0"
      >
        <div v-if="arrow">
          <!-- Arrow to swipe right and left -->
          <a @click="left()" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>
          </a>
          <a @click="right()">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>
          </a>
        </div>
      </b-col>
      <!-- Previous next pagination -->
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 pl-0">
        <template v-if="total_count > show">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{
                      name: 'AccountSettings',
                      query: {
                        page: page - 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{
                    name: 'AccountSettings',
                    query: {
                      page: 1,
                      show: count,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                  >First</router-link
                >
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{
                      name: 'AccountSettings',
                      query: {
                        page: page - 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >Previous</router-link
                  >
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > page * count">
                  <router-link
                    class="page-link"
                    :to="{
                      name: 'AccountSettings',
                      query: {
                        page: page + 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >Next</router-link
                  >
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{
                    name: 'AccountSettings',
                    query: {
                      page: Math.ceil(total_count / count),
                      show: count,
                      search: search_criteria,
                      status: status,
                      sort: sort,
                      label: label,
                      custom: custom,
                    },
                  }"
                  >Last</router-link
                >
              </li>
              <li class="page-item">
                <template v-if="total_count > page * count">
                  <router-link
                    class="page-link"
                    :to="{
                      name: 'AccountSettings',
                      query: {
                        page: page + 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
        <!-- End of pagination -->
      </b-col>
    </b-row>

    <back-to-top
      :visibility-height="300"
      :back-position="50"
      transition-name="fade"
    />
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Accounts'"
      @downloaded="export_modal = false"
    />
    <!--  accouns form -->
    <AccountsForm :page="viewpage"></AccountsForm>
    <!--  bulk delete modal -->
    <DeleteRecord
      v-on:setDelete="getDelete"
      :value="value"
      module="accounts"
      content="The selected account(s) will be deleted and cannot be retrieved later. Are you sure about deleting them?"
    ></DeleteRecord>
    <LogRecord :message="logrecords"></LogRecord>
    <!-- Status change as active and inactive -->
    <b-modal
      id="statusPage"
      size="md"
      body-class="bg-white"
      cancel-title="No"
      cancel-variant="light"
      :ok-title-html="submitted == true ? loaderIcon + 'yes' : 'yes'"
      title="Status"
      @ok="handlestatus"
      button-size="sm"
    >
      <p>Are you sure you want to {{ statusPage }} the selected Accounts ?</p>
    </b-modal>
  </div>
</template>
<script>
//import needed functions, file , components and state
import { mapState } from "vuex"; //to use mapstate and to call from js file
import store from "@/store/index"; // to call all vuex state
import { notificationMixin } from "@/mixins/notification"; // notification is a global function to show notification success/error alert
import { EventBus } from "@/event-bus"; //To call the event from other function
import BackToTop from "@/components/BackToTop/index"; //To move to top details when we have more datas
import DeleteRecord from "@/components/Modal/DeleteModal"; // modal for deleting created credit used record
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
import AccountsForm from "@/components/Form/Accounts/AccountsForm"; // modal for accounts create and update form
// To fetch list for index page
function getPageAccounts(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const search = routeTo.query.search || "";
  const status = routeTo.query.status || "";
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  const custom = routeTo.query.custom || "";
  // get the list of data as per the requirements
  store
    .dispatch("accounts/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom,
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.search = search;
      routeTo.params.status = status;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      routeTo.params.custom = custom;
      next();
    });
}
export default {
  mixins: [notificationMixin], // register all your global function here to access as normal methods
  props: {
    // all your property
    page: {
      type: Number,
      required: true,
    },
    show: {
      type: Number,
      required: true,
    },
    search: [String, Number],
    status: [String, Number],
    label: [String, Number],
    sort: [String, Number],
    custom: [String, Number],
  },
  name: "AccountSettings",
  //components
  components: {
    BackToTop,
    DeleteRecord,
    LogRecord,
    AccountsForm,
  },
  data() {
    return {
      export_modal: false,
      //Datas to return
      submitted: false,
      arrow: false,
      export_data: [],
      export_xl: {
        //export in excel datas
        ID: "acc_code",
        "Accounts Name": "gl_acc_name",
        "Accounts Type": "gl_acc_type",
        "Accounts Description": "gl_acc_desc",
      },
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      statusPage: "", //status
      viewpage: "",
      logrecords: "",
      value: [],
      CheckedCount: 0,
      CheckedVdrIds: [],
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      checkboxes1: [],
      showDismissibleAlert: this.$route.query.search == "" ? false : true,
      total: 10,
    };
  },

  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    //To fetch Export datas
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const response = await store
        .dispatch("accounts/fetchaccountsexportLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom,
        })
        .then(() => {
          return this.export;
        });
      return response;
    },

    //Scroll left
    left() {
      const conent = this.$el.querySelector("#scrollCol");
      conent.scrollLeft -= 150;
      event.preventDefault();
    },
    //Right
    right() {
      const conent = this.$el.querySelector("#scrollCol");
      conent.scrollLeft += 150;
      event.preventDefault();
    },
    //Starting download for excel
    startDownload() {
      this.loader = "Loading...";
    },
    //Finish download for excel
    finishDownload() {
      this.loader = "Downloaded";
    },
    //To update form
    async callupdateaccountsmodal(index) {
      this.viewpage = await "update";
      await this.$root.$emit("bv::show::modal", "accountsform");
      await EventBus.$emit("updateFreshEventObject", this.lists[index]);
    },
    //To get the precent value
    getPresentValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i]["filter_id"];
          break;
        }
      }
      return hasMatch;
    },
    //Scroll bar for index
    scrollbar(e) {
      return e[0] ? e[0].scrollWidth > e.innerWidth() : false;
    },
    //  detelted record details
    getDelete() {
      const currentPage = 1;
      const show = 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const update_status = update == true ? false : true;
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          update: update_status,
        },
      });

      this.logrecords =
        this.message.message.length == 0
          ? this.message.success
          : this.message.message;
      this.$root.$emit("bv::show::modal", "loglist");
    },
    //handle status
    //handle status
    handlestatus() {
      var ids = this.checkboxes1;
      ids = ids.filter((item) => item !== false && item !== true);
      this.submitted = true;
      var data = JSON.stringify({
        name: this.statusPage,
        status: ids,
      });
      store.dispatch("accounts/statuschange", data).then(() => {
        this.CheckedCount = 0;
        this.checkboxes1 = [];
        this.submitted = false;
        this.getDelete();
      });
    },
    //  call delete modal
    deletemodal() {
      var ids = this.checkboxes1;
      ids = ids.filter((item) => item !== false && item !== true);
      this.value = ids;
      this.$root.$emit("bv::show::modal", "invoicedelete");
    },
    //Call accounts form
    async accountsform() {
      this.viewpage = await "create";
      await this.$root.$emit("bv::show::modal", "accountsform");
      await EventBus.$emit("createFreshEventObject");
    },
    //Checkbox event
    checkAll(ev) {
      var fields = this;
      fields.lists.map(function (value, index) {
        fields.checkboxes1[index + 1] =
          ev.target.checked == true ? value.gl_acc_id : false;
      });
      this.CheckedCount =
        ev.target.checked == true
          ? (this.page - 1) * this.show + this.lists.length
          : 0;
    },
    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var gl_acc_ids = this.checkboxes1;
      gl_acc_ids = gl_acc_ids.filter((item) => item !== false);
      // check all if page length matches
      if (gl_acc_ids.length == this.lists.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }
      if (this[checkbox][id] != false) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    },
  },
  // called synchronously after the vue instance created
  created() {
    var check = [false];
    var i;
    for (i = 0; i < this.total; i++) {
      check.push(false);
    }

    this.checkboxes1 = check;
    this.CheckedCount = 0;
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
  //Function for updating
  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  // function will be called before route enter ( to get all the api datas before page loading)
  beforeRouteEnter(routeTo, routeFrom, next) {
    // function will be called before route enter ( to get all the api datas before page loading)
    store.dispatch("accounts/fetchAccountDetails");
    getPageAccounts(routeTo, next);
  },
  // function will be called before route update ( to get all the api datas before page loading)
  beforeRouteUpdate(routeTo, routeFrom, next) {
    this.CheckedCount = 0;
    this.checkboxes1 = [];
    getPageAccounts(routeTo, next);
  },

  computed: {
    // to get the required data from the vuex state
    ...mapState({
      lists: (state) => state.accounts.lists, // to show the data inside the table file
      total_count: (state) => state.accounts.total_count, // to show the total count of the data inside the table file
      count: (state) => state.accounts.count, // to show the  counts of the data inside the table file
      search_criteria: (state) => state.accounts.search_criteria, // to show the  search criteria name inside the table file
      filter_list: (state) => state.accounts.filter_list, // to show the  dropdown of filter list name inside the table file
      filter_name: (state) => state.accounts.filter_name, // to show the  name of the selected filter list name inside the table file
      delete: (state) => state.accounts.delete, //for delete action
      code: (state) => state.accounts.code, //To get the code
      is_no_records: (state) => state.accounts.is_no_records, // to check for an record in the database
      message: (state) => state.accounts.log_details, //To show the error message while
      export: (state) => state.accounts.export, //to show the exported datas
    }),
  },
};
</script>